module.exports = "<div class=\"pop-600\">\n    <header class=\"dialog-header no-btm-margin flex-item\">\n        <h3>{{ title }}</h3>\n        <button md-dialog-close class=\"close-btn\">\n            <i class=\"material-icons\">clear</i>\n        </button>\n    </header>\n    <form name=\"taskGuideForm\" novalidate>\n        <div>{{ guideText }}</div>\n    </form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/task/taskguide/task-guide.component.html
// module id = 2349
// module chunks = 0